import { gsap } from "gsap";

export function startLoopingItems() {
  const track = document.querySelector(".is-realisations--wrap");
  const items = gsap.utils.toArray(".is-realisations--item");

  if (!track || items.length === 0) return;

  // 1. Clone les items pour créer une continuité visuelle
  items.forEach(item => {
    const clone = item.cloneNode(true);
    track.appendChild(clone);
  });

  // 2. Calcul de la largeur du contenu défilant
  const totalWidth = track.scrollWidth / 2;

  // 3. Animation de défilement infini fluide
  gsap.to(track, {
    x: `-=${totalWidth}`,
    duration: 20,
    ease: "none",
    repeat: -1,
    modifiers: {
      x: gsap.utils.unitize(x => parseFloat(x) % totalWidth)
    }
  });
}
